import React, { useEffect } from "react";

import { AppRoutes } from "../routes";
import "../assets/scss/themes.scss";
import i18n from "../i18n";
import { Languages } from "../data/languages";
import { ToastContainer } from "react-toastify";

export const App: React.FunctionComponent = () => {
  useEffect(() => {
    configureLanguage(localStorage.getItem("i18nextLng") || "en");
  }, []);

  const configureLanguage = (locale: string) => {
    const html = window.document.documentElement;
    const language = Languages[locale === "ar" ? "ar" : "en"];
    html.lang = locale;
    html.dir = language.dir;
    i18n.changeLanguage(locale);
  };
  return (
    <React.Fragment>
      <ToastContainer
        position={"bottom-right"}
        closeButton={true}
        closeOnClick={true}
      />
      <AppRoutes />
    </React.Fragment>
  );
};
